<template>
    <!-- Modal Wrapper with Transition -->
    <Transition name="modal" appear>
        <div 
            v-if="$modal.isOpen" 
            class="fixed inset-0 z-50 flex items-center justify-center"
        >
            <!-- Backdrop -->
            <Transition name="backdrop" appear>
                <div 
                    v-if="$modal.isOpen"
                    class="absolute inset-0 bg-black bg-opacity-50"
                    @click="$modal.closeModal"
                ></div>
            </Transition>
            
            <!-- Modal -->
            <Transition name="modal-content" appear>
                <div
                    v-if="$modal.isOpen"
                    class="relative bg-white rounded shadow-xl max-w-2xl w-full mx-4 overflow-visible"
                >
                    <!-- Close Button -->
                    <button
                        @click="$modal.closeModal"
                        class="absolute top-4 right-4 z-20 p-1 text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Close modal"
                    >
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>

                    <!-- Dynamic Integration Component -->
                    <component
                        :is="getCurrentIntegrationComponent()"
                        :integration="$modal.currentIntegration"
                        @connected="handleIntegrationConnected"
                        @disconnected="handleIntegrationDisconnected"
                    />
                </div>
            </Transition>
            
        </div>
    </Transition>
</template>

<script setup>
import { useIntegrationModal } from '../stores/integrationModal'
import { useIntegrations } from '../stores/integrations'

const $modal = useIntegrationModal()
const $integrations = useIntegrations()

// Get the component for the current integration
const getCurrentIntegrationComponent = () => {
    if (!$modal.currentIntegration?.id) {
        console.log('No integration ID found')
        return null
    }

    // The configs object contains integration ID to component mapping
    // For example: { 'fluent-crm': FluentCRM }
    console.log('Available configs:', $modal.modalContents)
    console.log('Looking for integration ID:', $modal.currentIntegration.id)
    console.log('Found component:', $modal.modalContents[$modal.currentIntegration.id] || null)

    return $modal.modalContents[$modal.currentIntegration.id] || null
}

// Handle integration connected event
const handleIntegrationConnected = (data) => {
    if ($modal.currentIntegration) {
        $integrations.updateIntegrationConnectionStatus($modal.currentIntegration.id, true)
    }
}

// Handle integration disconnected event
const handleIntegrationDisconnected = () => {
    if ($modal.currentIntegration) {
        $integrations.updateIntegrationConnectionStatus($modal.currentIntegration.id, false)
    }
}
</script>

<style scoped>
/* Modal wrapper transition */
.modal-enter-active, .modal-leave-active {
    transition: all 0.3s ease;
}

.modal-enter-from, .modal-leave-to {
    opacity: 0;
}

.modal-enter-to, .modal-leave-from {
    opacity: 1;
}

/* Backdrop transition */
.backdrop-enter-active, .backdrop-leave-active {
    transition: opacity 0.3s ease;
}

.backdrop-enter-from, .backdrop-leave-to {
    opacity: 0;
}

.backdrop-enter-to, .backdrop-leave-from {
    opacity: 1;
}

/* Modal content transition */
.modal-content-enter-active, .modal-content-leave-active {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-content-enter-from, .modal-content-leave-to {
    opacity: 0;
    transform: scale(0.7) translateY(-50px);
}

.modal-content-enter-to, .modal-content-leave-from {
    opacity: 1;
    transform: scale(1) translateY(0);
}
</style>